<template></template>
<script>
import { first, length, map, merge, object_map } from "@pdfking/rfunc"
import { Identity, Keys, Values } from "@pdfking/tfunc"
import MiniSearch from "minisearch"

import slugify from "../utils/slugify"

// abstract class needs to implement methods:
//
// filter_results
// default_results
//
// needs to implement props
//
// query

const create_search_index = (options, documents) => {
  const index = new MiniSearch(
    merge({ storeFields: Keys(first(documents)) }, options)
  )

  index.addAll(documents)

  return index
}

export default {
  computed: {
    index() {
      if (length(this.all_options)) {
        return create_search_index(
          {
            fields: ["unicode", "slug", "search_keys"],
            idField: "id",
            searchOptions: {
              boost: { Keys: 4, slug: 7, unicode: 10 },
              fuzzy: 0.2,
              prefix: true,
            },
          },
          map(
            i => merge(i, { slug: slugify(i.unicode) }),
            Values(this.all_options)
          )
        )
      }
      return null
    },
    results() {
      if (this.debouncedQuery && this.index)
        return object_map(
          v => v.id,
          Identity,
          this.index.search(this.debouncedQuery)
        )
      return this.default_results || []
    },
  },
  data() {
    return {
      debouncedQuery: "",
      is_loading: true,
      searchTimeout: null,
    }
  },
  methods: {
    filter_results: Identity,
  },
  watch: {
    query: {
      handler(q) {
        // Clear existing timeout
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }

        // Set debounced query after 300ms delay
        this.searchTimeout = setTimeout(() => {
          this.debouncedQuery = (q || "").trim()
          this.is_loading = false
        }, 250)
      },
      immediate: true,
    },
  },
}
</script>
